import React from 'react'
import PoolAdd from './PoolAdd';
import PoolConnect from './PoolConnect';

function Pool() {

  return (

    <div className="pool">
      {/* <PoolConnect/> */}
      <PoolAdd />
    </div>
  
  )
}

export default Pool